var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 85,
    viewBox: "0 0 202 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.844,
    height: 23.1339,
    rx: 1.30581,
    transform: "matrix(-1 0 0 1 160.639 61.1326)",
    fill: "#E9E4F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.504,
    y: 61.1326,
    width: 29.6403,
    height: 23.1339,
    rx: 1.30581,
    fill: "#C0B7D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.695,
    y: 61.46,
    width: 121.453,
    height: 23.1339,
    rx: 1.30581,
    fill: "#C0B7D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.061,
    y: 61.1326,
    width: 4.57034,
    height: 23.1339,
    rx: 1.30581,
    fill: "#F4F2F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.208,
    y: 61.1326,
    width: 9.79358,
    height: 23.1339,
    rx: 1.30581,
    fill: "#C0B7D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.7964,
    y: 61.1326,
    width: 20.9651,
    height: 23.1339,
    rx: 1.30581,
    fill: "#EEE7DF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5884,
    y: 56.394,
    width: 77.3001,
    height: 60.2229,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.9302,
    y: 30.7694,
    width: 67.9557,
    height: 101.934,
    fill: "#E9E4F1"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 62.893,
    height: 23.1339,
    rx: 1.30581,
    transform: "matrix(-1 0 0 1 110.97 30.7694)",
    fill: "#BEE0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.98,
    y: 30.7694,
    width: 22.1988,
    height: 23.1339,
    rx: 1.30581,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.278,
    y: 30.7694,
    width: 10.4465,
    height: 23.1339,
    rx: 1.30581,
    fill: "#E9E4F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.453,
    y: 30.7694,
    width: 136.634,
    height: 23.1339,
    rx: 1.30581,
    fill: "#E9E4F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.3615,
    y: 31.1309,
    width: 13.7357,
    height: 22.4109,
    rx: 0.944344,
    stroke: "#E9E4F1",
    strokeWidth: 0.722933
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80.334,
    height: 23.1339,
    rx: 1.30581,
    transform: "matrix(-1 0 0 1 146.818 0.40625)",
    fill: "#BEE0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.32,
    y: 1.09511,
    width: 34.7008,
    height: 22.4109,
    rx: 0.944344,
    stroke: "#BEE0FF",
    strokeWidth: 0.722933
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9521,
    y: 0.40625,
    width: 20.9651,
    height: 23.1339,
    rx: 1.30581,
    fill: "#E9E4F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 85,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.7139,
    y: 61.1326,
    width: 23.8568,
    height: 23.1339,
    rx: 0.952735,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.6ab67446e46d0988dec08738f302fda8.svg";
export { ForwardRef as ReactComponent };